import { Dropdown, DropdownOption } from '@sunwebgroup/ui-components';
import { isEmpty } from 'ramda';

import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks';
import { createPricesFilterClickEvent } from '@/domain/prices/analytics/index';
import { useSelectFilter, usePriceFilters } from '@/domain/prices/filters/hooks';
import { usePrices } from '@/domain/prices/prices/hooks';
import { PricesFilter } from '@/react-pages/Prices/Filters/BaseFilter';
import { useIntl } from '../../../intl';
import { useOptimizelyFlagContext } from '@/scopes/common/infrastructure/ab-testing/useOptimizely';

export function TransportTypeFilter() {
  const intl = useIntl();
  const { isEmptyResponse } = usePriceFilters();
  const { sendEvent } = useAnalytics();
  const { options, selectedValue, setSelection } = useSelectFilter('TransportType');
  const { isFetching } = usePrices();
  const { hideFilterVariant } = useOptimizelyFlagContext();
  const doNotRender =
    (isEmpty(options) && !isEmptyResponse) || (hideFilterVariant && isEmpty(options) && isEmpty(selectedValue));

  if (doNotRender) {
    return null;
  }

  const handleFilterChange = (value?: string) => {
    if (value) {
      setSelection(value);
      sendEvent(
        createPricesFilterClickEvent({
          element: 'dropdown',
          type: 'transport',
          result: value,
        })
      );
    } else {
      setSelection(null);
    }
  };

  return (
    <PricesFilter.Root>
      <PricesFilter.Label>{intl.formatMessage({ id: 'prices_filters_transporttype_label' })}</PricesFilter.Label>
      <PricesFilter.Control $isDisabled={isFetching || isEmpty(options)}>
        <Dropdown
          icon="IconAirplane"
          placeholder={intl.formatMessage({ id: 'prices_filters_transporttype_placeholder' })}
          value={selectedValue}
          onValueChange={handleFilterChange}
          disablePlaceholder
        >
          {options.map(({ name, value }) => (
            <DropdownOption key={value} value={value}>
              {name}
            </DropdownOption>
          ))}
        </Dropdown>
      </PricesFilter.Control>
    </PricesFilter.Root>
  );
}
